import { Component, OnInit, OnDestroy } from '@angular/core';
import { FieldType } from 'ng-formly';
import { LoopBackFilter } from '../../sdk/models/';
import * as _ from "lodash";
import { LoopBackAuth } from '../../sdk/services/core/auth.service';
import { PlatformApp } from '../../services/app.service';
import {
	AccountApi,
	ActivityApi,
	AggregatesApi,
	AppApi,
	ApptypeApi,
	CounterApi,
	CurrencyApi,
	DashboardApi,
	DataelementApi,
	EntityApi,
	EntitycompactlayoutApi,
	EntityfieldApi,
	EntitylistlayoutApi,
	EntitypagelayoutApi,
	EntityrecordApi,
	EntityrecordhistoryApi,
	EntitysearchlayoutApi,
	InstallationApi,
	MenuitemApi,
	NoteApi,
	NotificationApi,
	PaastenantApi,
	PicklistApi,
	ProfileApi,
	ReportdownloadApi,
	ReporttemplateApi,
	TenantApi
} from '../../sdk/services/custom';

@Component({
	selector: 'formly-component-selector',
	template: `
   			<ng-select *ngIf="items.length > 0"   
              	[active]="selectedvalues"
              	(data)="refreshValue($event)"
              	(selected)="selected($event)"
              	(removed)="removed($event)"
              	[items]="items"
              	[multiple]="false"
               	[disabled]="to.disabled"
              	placeholder=""
				[allowClear]="!to.required" >
  			</ng-select>
  `, styleUrls: ['./ng2select.scss'],
	providers: [
		AccountApi,
		ActivityApi,
		AggregatesApi,
		AppApi,
		ApptypeApi,
		CounterApi,
		CurrencyApi,
		DashboardApi,
		DataelementApi,
		EntityApi,
		EntitycompactlayoutApi,
		EntityfieldApi,
		EntitylistlayoutApi,
		EntitypagelayoutApi,
		EntityrecordApi,
		EntityrecordhistoryApi,
		EntitysearchlayoutApi,
		InstallationApi,
		MenuitemApi,
		NoteApi,
		NotificationApi,
		PaastenantApi,
		PicklistApi,
		ProfileApi,
		ReportdownloadApi,
		ReporttemplateApi,
		TenantApi
	]
})

/**
 * To be Used only in Core and Platform for Accessing API Components
 */
export class RecordSelect extends FieldType implements OnInit, OnDestroy {
	_loopbackfilter: LoopBackFilter = <LoopBackFilter>{};
	items: any = [];
	currentuser;
	appId;
	formulae = [];
	modelValues = [];
	selectedvalues: any = [];

	constructor(
		private _AccountApi: AccountApi,
		private _ActivityApi: ActivityApi,
		private _AggregatesApi: AggregatesApi,
		private _AppApi: AppApi,
		private _ApptypeApi: ApptypeApi,
		private _CounterApi: CounterApi,
		private _CurrencyApi: CurrencyApi,
		private _DashboardApi: DashboardApi,
		private _DataelementApi: DataelementApi,
		private _EntityApi: EntityApi,
		private _EntitycompactlayoutApi: EntitycompactlayoutApi,
		private _EntityfieldApi: EntityfieldApi,
		private _EntitylistlayoutApi: EntitylistlayoutApi,
		private _EntitypagelayoutApi: EntitypagelayoutApi,
		private _EntityrecordApi: EntityrecordApi,
		private _EntityrecordhistoryApi: EntityrecordhistoryApi,
		private _EntitysearchlayoutApi: EntitysearchlayoutApi,
		private _InstallationApi: InstallationApi,
		private _MenuitemApi: MenuitemApi,
		private _NoteApi: NoteApi,
		private _NotificationApi: NotificationApi,
		private _PaastenantApi: PaastenantApi,
		private _PicklistApi: PicklistApi,
		private _ProfileApi: ProfileApi,
		private _ReportdownloadApi: ReportdownloadApi,
		private _ReporttemplateApi: ReporttemplateApi,
		private _TenantApi: TenantApi,
		private _LoopBackAuth: LoopBackAuth) {
		super();
	}

	ngOnInit() {
		if (!this.form['subscriptions'])
			this.form['subscriptions'] = [];

		if (!this.form['newcontrols'])
			this.form['newcontrols'] = {};

		for (var key in this.form.controls)
			this.form['newcontrols'][key] = this.form.controls[key];

		if (this.field['formulae']) {
			this.formulae = this.field['formulae'];
			if (this.field.formControl)
				this.addWatcher(this.field.formControl);
		}

		this.currentuser = this._LoopBackAuth.getCurrentUserData();
		if (PlatformApp.getAppVariable("platformApp"))
			this.appId = PlatformApp.getAppVariable("referenceAppId");
		else
			this.appId = this.currentuser.appId

		this._loopbackfilter.where = { 'appId': this.appId };

		// Set to.type as the DataSource Name to pull Data
		// To use this Switch Case option for General Select
		// Setup the to.type as null
		switch (this.to.type) {
			case 'account':
				this.populateDbValues(this._AccountApi, 'id', 'name');
				break;

			case 'activity':
				this.populateDbValues(this._ActivityApi, 'id', 'name');
				break;

			case 'aggregates':
				this.populateDbValues(this._AggregatesApi, 'id', 'name');
				break;

			case 'app':
				this.populateDbValues(this._AppApi, 'id', 'name');
				break;

			case 'apptype':
				this.populateDbValues(this._ApptypeApi, 'id', 'name');
				break;

			case 'counter':
				this.populateDbValues(this._CounterApi, 'id', 'name');
				break;

			case 'currency':
				this.populateDbValues(this._CurrencyApi, 'id', 'name');
				break;

			case 'dashboard':
				this.populateDbValues(this._DashboardApi, 'id', 'name');
				break;

			case 'dataelement':
				this.populateDbValues(this._DataelementApi, 'id', 'name');
				break;

			case 'entity':
				this.populateDbValues(this._EntityApi, 'id', 'name');
				break;

			case 'entitycompactlayout':
				this.populateDbValues(this._EntitycompactlayoutApi, 'id', 'name');
				break;

			case 'entityfield':
				this.populateDbValues(this._EntityfieldApi, 'id', 'name');
				break;

			case 'entitylistlayout':
				this.populateDbValues(this._EntitylistlayoutApi, 'id', 'name');
				break;

			case 'entitypagelayout':
				this.populateDbValues(this._EntitypagelayoutApi, 'id', 'name');
				break;

			case 'entityrecord':
				this.populateDbValues(this._EntityrecordApi, 'id', 'name');
				break;

			case 'entityrecordhistory':
				this.populateDbValues(this._EntityrecordhistoryApi, 'id', 'name');
				break;

			case 'entitysearchlayout':
				this.populateDbValues(this._EntitysearchlayoutApi, 'id', 'name');
				break;

			case 'installation':
				this.populateDbValues(this._InstallationApi, 'id', 'name');
				break;

			case 'menuitem':
				this.populateDbValues(this._MenuitemApi, 'id', 'name');
				break;

			case 'note':
				this.populateDbValues(this._NoteApi, 'id', 'name');
				break;

			case 'notification':
				this.populateDbValues(this._NotificationApi, 'id', 'name');
				break;

			case 'paastenant':
				this.populateDbValues(this._PaastenantApi, 'id', 'name');
				break;

			case 'picklist':
				this.populateDbValues(this._PicklistApi, 'id', 'name');
				break;

			case 'profile':
				this.populateDbValues(this._ProfileApi, 'id', 'name');
				break;

			case 'reportdownload':
				this.populateDbValues(this._ReportdownloadApi, 'id', 'name');
				break;

			case 'reporttemplate':
				this.populateDbValues(this._ReporttemplateApi, 'id', 'name');
				break;

			case 'tenant':
				this.populateDbValues(this._TenantApi, 'id', 'name');
				break;

			default:
				this.to.disabled = true;
				this.to.placeholder = 'API Type Missing / Wrong' + this.to.type;
				break;
		}
	}

	populateDbValues(currentApi, idFieldName, textFieldName) {
		this.form['subscriptions'].push(currentApi.find(this._loopbackfilter).subscribe((results) => {

			if (results && results.length && results.length > 0)
				for (var i = 0; i < results.length; i++) {
					let idValue = results[i][idFieldName];
					let textValue = results[i][textFieldName];

					if (this.model.id !== idValue)
						this.items.push({ id: idValue, text: textValue });

					if (this.model[this.key] && this.model[this.key].indexOf(idValue) > -1) {
						this.selectedvalues = [{ id: idValue, text: textValue }];
					}
				}
			this.items = _.sortBy(this.items, 'text');
		}));
	}

	addWatcher(formControl) {
		this.form['subscriptions'].push(formControl.valueChanges.subscribe((updatedValue: any) => {
			for (var i = 0; i < this.formulae.length; i++) {
				var formula = this.formulae[i];
				if (this.setModelValues(formula['fields'], updatedValue))
					this.setResults(formula['results'], PlatformApp.processData(formula['formula'], this.modelValues));
			}
		}));
	}

	setModelValues(fieldArray, updatedValue) {
		var requiredFieldsExist = true;
		this.modelValues = [];
		for (var j = 0; j < fieldArray.length; j++) {
			if (!this.model[fieldArray[j]]) {
				requiredFieldsExist = false;
				break;
			} else {
				if (fieldArray[j] == this.field.key)
					this.modelValues.push(updatedValue);
				else
					this.modelValues.push(this.model[fieldArray[j]]);
			}
		}
		return requiredFieldsExist;
	}

	setResults(resultArray, value): void {
		for (var i = 0; i < resultArray.length; i++) {
			var resultField = resultArray[i];
			if (this.form.controls[resultField]) {
				this.form.controls[resultField].setValue(value);

				if (this.form['newcontrols'][resultField] && !this.model[resultField]) {
					this.form.setControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				}
			} else {
				if (this.form['newcontrols'][resultField]) {
					this.form.addControl(resultField, this.form['newcontrols'][resultField]);
					this.form.controls[resultField].setValue(value);
				} else
					this.model[resultField] = value;
			}
		}
	}
	ngOnDestroy() {
	}

	public selected(value: any): void {
		if (value && value.id)
			this.formControl.setValue(value.id);

		for (var key in this.form['newcontrols'])
			this.form.setControl(key, this.form['newcontrols'][key]);
	}

	public removed(value: any): void {
		if (value && value.id)
			if (this.model[this.key] && this.model[this.key].length)
				this.model[this.key].splice(this.model[this.key].indexOf(value.id), 1);
	}

	public typed(): void {
	}

	public refreshValue(value: any): void {
	}

}



// WEBPACK FOOTER //
// ./src/app/shared/components/fields/selectrecord.ts